import { useContext } from 'react'
import React from 'react'
import { CreateCart } from '__generated__/types'

export type CartContextData = {
  cartUuid: string | undefined
  recreateCart: () => Promise<CreateCart.CreateCart | null | undefined>
  removeCartUuid: () => void
}

const CartContext = React.createContext<CartContextData>({
  cartUuid: undefined,
  recreateCart: () => Promise.resolve(undefined),
  removeCartUuid: () => {}
})

export default CartContext

export const useCartContext = (): CartContextData => useContext(CartContext)
